<template>
   <div :class="{ 'has-logo': isCollapse }" >
      <Transition name="sidebarLogoFade">
        <div class="logo"  v-if="!isCollapse">
          <!-- <img :src="logo" alt="" class="sidebar-logo" /> -->
          <h1>{{title}}</h1>
        </div>
        <div class="logo"  v-else>
          <img :src="logo" alt="" class="sidebar-logo" />
        </div>
      </Transition>


    <el-scrollbar class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :unique-opened="true"
        :collapse-transition="false"
        active-text-color="rgb(64, 158, 255)"
        background-color="rgb(48, 65, 86)"
        class="el-menu-vertical-demo"
        default-active="2"
        text-color="#fff"
        mode="vertical"
        :router="true"
        @select="handleSelect"
      >
        <sidebar-item
          v-for="(route, index) in menulist"
          :key="route.path + index"
          :item="route"
          :base-path="route.path"
          :currentPath="currentPath"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>
<script setup>
import { ref, Transition } from 'vue';
import logo from '@/assets/logo/logo.png'
import SidebarItem from './SidebarItem.vue'
 import { usePermissionStore } from '@/store/modules/permission'
import { useAppStore } from '@/store/modules/app'
import { useRouter, useRoute } from 'vue-router';

const title=import.meta.env.VITE_BASE_TITLE;
 const usePermission = usePermissionStore();
const appStore = useAppStore()
const currentPath = ref('');
const router = useRouter()
const route = useRoute()

const menulist = computed(() => {
   return usePermission.getterMenuListInfo
})

let activeMenu = ref()
const isCollapse = computed(() => !appStore.sidebar.opened);

function handleSelect(e) {
  currentPath.value = e;
}

onMounted(() => {
  currentPath.value = route.path
})

</script>
<style lang="scss" scoped>
.logo {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  height: 50px;
  h1 {
    font-size: 14px;
  }
  img {
    width: 32px;
    height: 32px;
    margin-right: 10px;
  }
}

.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter-from,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.scrollbar-wrapper {
  height: calc(100% - 50px);
}
</style>